import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaTiktok,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt
} from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">

      <div className="footer-content">

        {/* Column 1 – Branding */}
        <div className="footer-col">
          <h2 className="footer-title">Dine at Namaste</h2>

          <p className="footer-address">
            <FaMapMarkerAlt className="footer-icon" />
            170 McNaughton Ave W<br />
            Chatham, ON N7L 1R2
          </p>

          <p className="footer-contact">
            <FaEnvelope className="footer-icon" />
            info@thenamaste.ca
          </p>

          <p className="footer-contact">
            <FaPhoneAlt className="footer-icon" />
            (519) 397-1345
          </p>
        </div>

        {/* Column 2 – Hours */}
        <div className="footer-col">
          <h3 className="footer-subtitle">Hours</h3>

          <p>Sun: <strong>4pm – 9pm</strong></p>
          <p>Mon – Thu: <strong>11:30am – 9pm</strong></p>
          <p>Fri – Sat: <strong>11:30am – 9:30pm</strong></p>
        </div>

        {/* Column 3 – Social Icons */}
        <div className="footer-col">
          <h3 className="footer-subtitle">Follow Us</h3>

          <div className="footer-socials">
            <a href="#" className="social-icon facebook">
              <FaFacebookF />
            </a>
            <a href="#" className="social-icon instagram">
              <FaInstagram />
            </a>
            <a href="#" className="social-icon tiktok">
              <FaTiktok />
            </a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} Namaste Restaurant & Bar — Chatham, Ontario
      </div>

    </footer>
  );
}

export default Footer;
